import styled from 'styled-components';

export const ReportButtonCotainer = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
`;
